import axios from "axios";
import {
  BASE_URL,
  DELETE_LETTER_USER,
  DOWNLOAD_LETTER,
  DOWNLOAD_LETTER_QR,
  COURSE_CATEGORY,
  COURSE_CATEGORY_LIST,
  CHANNEL_PARTNER,
  CHANNEL_PARTNER_LIST,
  CITY_LIST,
  DOWNLOAD_QR_CODE,
  GENERATE_FINAL_LETTER,
  LETTER,
  INSTRUCTOR,
  INSTRUCTOR_LIST,
  LOGIN,
  LOGOUT,
  PREREQUISITES_DOCUMENT,
  PREREQUISITES_DOCUMENT_LIST,
  RESEND_OTP,
  SA_LETTER_APPROVAL,
  SA_LETTERS_LIST,
  RESET_PASSWORD,
  SKILLS,
  SKILLS_LIST,
  TAGS,
  TAGS_LIST,
  TRAINEE,
  STATE_LIST,
  TRAINEE_LIST,
  TRAINING_CENTER,
  TRAINING_CENTER_LIST,
  VERIFY_OTP,
  VISITOR,
  VISITOR_LIST,
  LETTER_REQUEST_APPROVAL,
  LETTER_TEMPLATE_CONTENT,
  DELETE_TOOL_ITEMS,
  CHANGE_PASSWORD,
  ADMIN,
  ADMIN_LIST,
  ADD_CITY,
  QUESTION_BANK,
  QUESTION_BANK_LIST,
  QUESTION_DIFFICULTY,
  QUESTION,
  BATCH,
  BATCH_LIST,
  COURSE_NAME,
  ACTIVE_COURSE_NAME,
  COURSE_NAME_LIST,
  COURSE_DOCUMENT,
  COURSE_DOCUMENT_LIST,
  COURSE,
  LESSON,
  LESSON_COURSE,
  CERTIFICATE_TEMPLATE,
  CERTIFICATE_TEMPLTE_LIST,
  SIGNATURE,
  SIGNATURE_LIST,
  COURSE_LIST,
  RECEIPT_LIST,
  RECEIPT_DOWNLOAD,
  COURSE_ENROLLMENT,
  TRAINEE_DOCUMENTS,
  GET_COURSES_BATCHES,
  GET_LESSONS,
  ADD_ATTENDANCE,
  PAYMENT_LIST,
  PAYMENT_DETAILS,
  GET_SESSION,
  APPROVE_REJECT_PAYMENT,
  BATCH_COURSE,
  BATCH_SCHEDULED_DATES,
  ASSESSMENT,
  ASSESSMENT_LIST,
  INSTRUCTOR_COURSES,
  INSTRUCTOR_BATCH_LIST,
  ADMINS_COURSES_AND_BATCHES,
  ADMINS_SESSIONS_LIST,
  ADMINS_SESSIONS_WISE_ATTENDANCE_LIST,
  CHANNEL_PARTNER_COURSES_AND_BATCHES,
  CHANNEL_PARTNER_SESSIONS_WISE_ATTENDANCE_LIST,
  DOCUMENT_APPROVALS,
  ASSESSMENT_ARTIFACT,
  ASSESSMENT_ARTIFACT_LIST,
  COURSE_RATINGS,
  DELETE_COURSE_RATING,
  GET_ATTENDANCE,
  TRAINEE_ASSESSMENT_LIST,
  TRAINEE_ASSESSMENT_ARTIFACT_FILES,
  CHANNEL_PARTNER_ENROLLED_COURSES_LIST,
  CHANNEL_PARTNER_ENROLLED_COURSE_SCHEDULE,
  ENROLLED_COURSE_REVIEWS,
  CHANNEL_PARTNER_TRAINEE_ENROLLED_COURSE_ATTENDANCE,
  COURSE_RATING,
  CHANNEL_PARTNER_ENROLLED_COURSE_DETAILS,
  PENDING_ENROLLED_TRAINEES_LIST,
  ENROLLED_TRAINEE_LIST_AGAINST_COURSE,
  UPCOMING_BATCHES,
  INSTRUCTOR_PROFILE,
  ADMIN_PROFILE,
  CHANNEL_PARTNER_COURSE_LIST,
  CHANNEL_PARTNER_PROFILE,
  ISSUANCE_LIST,
  ISSUANCE_ELIGIBLE_TRAINEES,
  USER_CERTIFICATES_BATCH,
  GENERATE_USER_CERTIFICATE,
  PAYMENT_APPROVAL_REQUEST_LIST,
  TRAINEE_CERTIFICATES,
  TRAINEE_CERTIFICATE_IMAGE,
  ADMIN_DASHBOARD,
  CHANNEL_PARTNER_DASHBOARD_SUMMARY,
  CHANNEL_PARTNER_COURSE_ENROLLMENT_REPORT,
  CERTIFICATE_ISSUANCE_REPORT,
  ATTENDANCE_REPORT,
  CERTIFICATE_PENDING_REPORT,
  COURSE_ENROLLMENT_REPORT,
  INSTRUCTOR_DASHBOARD_SUMMARY,
  INSTRUCTOR_DAILY_ATTENDANCE_REPORT,
  INSTRUCTOR_ASSESSMENT_REPORT,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//To download invoice pdf, needs to pass responseType and headers
const API_FOR_QR = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

API_FOR_QR.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

// Login API
export const login_api = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const logout_api = () => API.post(`${LOGOUT}`);

// verify otp
export const verify_otp = (bodyData) => API.post(`${VERIFY_OTP}`, bodyData);

// resend otp
export const resend_otp = (bodyData) => API.post(`${RESEND_OTP}`, bodyData);

//visitor list
export const visitor_list = (pageNum, filters) =>
  API.get(VISITOR_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const get_visitor_by_Id = (id, pageNum, searchString) =>
  API.get(`${VISITOR}${id}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
    },
  });

// trainee List
export const trainee_list = (pageNum, filterParams, searchString) =>
  API.get(TRAINEE_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
    },
  });

// download QR code
export const download_qr_code = (traineeId) =>
  API_FOR_QR.get(`${DOWNLOAD_QR_CODE}${traineeId}`);

export const change_password = (bodyData) =>
  API.patch(CHANGE_PASSWORD, bodyData);
//reset password
export const set_password = (passwordData) =>
  API.patch(`${RESET_PASSWORD}`, passwordData);

// Training Center
export const add_training_center = (bodyData) =>
  API.post(TRAINING_CENTER, bodyData);
export const training_center_list = (pageNum, filterParams, searchString) =>
  API.get(TRAINING_CENTER_LIST, {
    params: {
      page: pageNum,
      ...(filterParams ? { filtersJSON: filterParams } : {}),
      ...(searchString ? { searchString } : {}),
    },
  });
export const get_training_center_by_ID = (id) =>
  API.get(`${TRAINING_CENTER}${id}`);
export const edit_training_center = (id, bodyData) =>
  API.patch(`${TRAINING_CENTER}${id}`, bodyData);

//course category list
export const course_category_list = (pageNum, filtersJSON) =>
  API.get(COURSE_CATEGORY_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//add course category
export const add_course_category = (bodyData) =>
  API.post(`${COURSE_CATEGORY}`, bodyData);

//edit or update course category
export const edit_course_category = (id, bodyData) =>
  API.patch(`${COURSE_CATEGORY}${id}`, bodyData);

//get details by id
export const get_courseCategory_details_ID = (id) =>
  API.get(`${COURSE_CATEGORY}${id}`);

//admins
export const add_admin = (formData) => API.post(ADMIN, formData);

export const get_admin_list = (pageNum, filters) =>
  API.get(ADMIN_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_admin_by_id = (id) => API.get(`${ADMIN}${id}`);

export const update_admin_by_id = (id, bodyData) =>
  API.patch(`${ADMIN}${id}`, bodyData);

//skills
export const add_skill = (formData) => API.post(SKILLS, formData);

export const get_skill_list = (pageNum, filters) =>
  API.get(SKILLS_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_skill_by_id = (id) => API.get(`${SKILLS}${id}`);

export const update_skill_by_id = (id, bodyData) =>
  API.patch(`${SKILLS}${id}`, bodyData);
//trainee
export const add_trainee = (bodyData) =>
  API.post(TRAINEE, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const edit_trainee = (id, bodyData) =>
  API.patch(`${TRAINEE}${id}`, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const get_trainee_details_by_ID = (id) => API.get(`${TRAINEE}${id}`);
export const get_trainee_letter = (pageNum, filterParams, userID) =>
  API.get(`${TRAINEE}letter`, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      userID: userID,
    },
  });
export const get_trainee_documents = (id) =>
  API.get(`${TRAINEE_DOCUMENTS}${id}`);
export const get_trainee_courses = (id, pageNum, filterParams) =>
  API.get(`${TRAINEE}${id}/enrolled-courses`, {
    params: {
      page: pageNum,
      ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
    },
  });
export const update_trainee_documents = (traineeId, bodyData) =>
  API.patch(`${TRAINEE_DOCUMENTS}${traineeId}`, bodyData);
export const delete_trainee_document = (id, data) =>
  API.delete(`${TRAINEE_DOCUMENTS}${id}`, { data });
export const upload_trainee_documents = (id, formData) =>
  API.post(`${TRAINEE}${id}/upload-prerequisite-documents`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

//letter
export const create_letter = (formData) =>
  API.post(LETTER, formData, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const request_letter_approval = (id) =>
  API.patch(`${LETTER_REQUEST_APPROVAL}${id}`);

export const update_letter = (id, formData) =>
  API.patch(`${LETTER}${id}`, formData, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const delete_letter = (id) => API.delete(`${LETTER}${id}`);

export const letter_list = (pageNum, filterParams, searchString, userID) =>
  API.get(LETTER, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(userID ? { userID } : {}),
    },
  });

export const get_letter_by_ID = (id) => API.get(`${LETTER}${id}`);

export const get_letter_template_content = (filterParams) =>
  API.get(LETTER_TEMPLATE_CONTENT, {
    params: {
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
    },
  });

export const delete_letter_user = (letterUserID) =>
  API.delete(`${DELETE_LETTER_USER}${letterUserID}`);

export const download__letter_qr = (id) =>
  API_FOR_QR.get(`${DOWNLOAD_LETTER_QR}${id}`);

export const download_letter = (id) =>
  API_FOR_QR.get(DOWNLOAD_LETTER, {
    params: {
      id: id,
    },
  });

export const generate_final_letter = (letterID) =>
  API.patch(`${GENERATE_FINAL_LETTER}${letterID}`);

// super admin api's
export const sa_letters_list = (pageNum, filterParams) =>
  API.get(SA_LETTERS_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
    },
  });

export const letter_request_approval = (letterID, bodyData) =>
  API.patch(`${SA_LETTER_APPROVAL}/${letterID}`, bodyData);

export const delete_tool_items = (letterID, bodyData) =>
  API.patch(`${DELETE_TOOL_ITEMS}/${letterID}`, bodyData);

//channel-partner
export const add_channel_partner = (formData) =>
  API.post(CHANNEL_PARTNER, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const get_channel_partner_list = (pageNum, filters) =>
  API.get(CHANNEL_PARTNER_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_channel_partner_by_id = (id) =>
  API.get(`${CHANNEL_PARTNER}${id}`);

export const update_channel_partner_by_id = (id, bodyData) =>
  API.patch(`${CHANNEL_PARTNER}${id}`, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

//city and state list
export const state_list = () => API.get(STATE_LIST);
export const city_list = (filtersJSON) =>
  API.get(`${CITY_LIST}`, {
    params: {
      filtersJSON,
    },
  });

//instructor list
export const instructor_list = (pageNum, filtersJSON) =>
  API.get(INSTRUCTOR_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

export const add_instructor = (bodyData) => API.post(`${INSTRUCTOR}`, bodyData);
export const edit_instructor = (id, bodyData) =>
  API.patch(`${INSTRUCTOR}${id}`, bodyData);

export const get_instructor_by_ID = (id) => API.get(`${INSTRUCTOR}${id}`);

//preRequisites document list
export const get_preRequisites_document_list = (pageNum, filtersJSON) =>
  API.get(PREREQUISITES_DOCUMENT_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//add preRequisites document

export const add_preRequisites_document = (bodyData) =>
  API.post(`${PREREQUISITES_DOCUMENT}`, bodyData);

//edit preRequisites document
export const edit_preRequisites_document = (id, bodyData) =>
  API.patch(`${PREREQUISITES_DOCUMENT}${id}`, bodyData);

export const add_city = (bodyData) => API.post(`${ADD_CITY}`, bodyData);

//tags
export const add_tag = (formData) => API.post(TAGS, formData);

export const get_tag_list = (pageNum, filters) =>
  API.get(TAGS_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_tag_by_id = (id) => API.get(`${TAGS}${id}`);

export const update_tag_by_id = (id, bodyData) =>
  API.patch(`${TAGS}${id}`, bodyData);

//question-banks
export const add_question_bank = (formData) =>
  API.post(QUESTION_BANK, formData);

export const get_question_bank_list = (pageNum, filters) =>
  API.get(QUESTION_BANK_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_question_bank_difficulty_list = (pageNum, filters) =>
  API.get(QUESTION_DIFFICULTY, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_question_bank_by_id = (id, pageNum, filters) =>
  API.get(`${QUESTION_BANK}${id}`, {
    params: {
      ...(pageNum ? { page: pageNum } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const update_question_bank_by_id = (id, bodyData) =>
  API.patch(`${QUESTION_BANK}${id}`, bodyData);

//question
export const add_question = (formData) => API.post(QUESTION, formData);
export const delete_question = (id) => API.delete(`${QUESTION}${id}`);

//batch
export const add_batch = (formData) => API.post(BATCH, formData);
export const get_batch_list = (pageNum, filters) =>
  API.get(BATCH_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const get_batch_by_id = (id) => API.get(`${BATCH}${id}`);
export const update_batch_by_id = (id, bodyData) =>
  API.patch(`${BATCH}${id}`, bodyData);
export const get_active_course_name_list = (pageNum, filters) =>
  API.get(ACTIVE_COURSE_NAME, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const get_course_enrollment_list = (id, pageNum, filterParams) =>
  API.get(`${COURSE_ENROLLMENT}${id}`, {
    params: {
      page: pageNum,
      ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
    },
  });

//course
export const add_course_name = (formData) => API.post(COURSE_NAME, formData);
export const get_course_name_list = (pageNum, filters) =>
  API.get(COURSE_NAME_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const add_course_document = (formData) =>
  API.post(COURSE_DOCUMENT, formData);
export const get_course_document_list = (pageNum, filters) =>
  API.get(COURSE_DOCUMENT_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const delete_course_name = (id) => API.delete(`${COURSE_NAME}${id}`);

export const add_course = (bodyData) =>
  API.post(COURSE, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const get_course_list = (
  pageNum,
  filterParams,
  searchString,
  sortOptionJSON,
) =>
  API.get(COURSE_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(sortOptionJSON
        ? { sortOptionJSON: JSON.stringify(sortOptionJSON) }
        : {}),
    },
  });
export const get_course_by_id = (id) => API.get(`${COURSE}${id}`);
export const inactive_course_batches = (id) => API.patch(`${BATCH_COURSE}${id}/inactive`);
//lesson
export const add_lesson = (formData) =>
  API.post(LESSON, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const update_lesson_by_id = (id, bodyData) =>
  API.patch(`${LESSON}${id}`, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const get_lessons_by_course_id = (id, pageNum, filters) =>
  API.get(`${LESSON_COURSE}${id}`, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const get_lesson_by_id = (id) => API.get(`${LESSON}${id}`);
export const delete_lesson = (id) => API.delete(`${LESSON}${id}`);

//certificate-template
export const add_certificate_template = (formData) =>
  API.post(CERTIFICATE_TEMPLATE, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const edit_certificate_template = (id, formData) =>
  API.patch(`${CERTIFICATE_TEMPLATE}${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const get_certificate_template_by_id = (id) =>
  API.get(`${CERTIFICATE_TEMPLATE}${id}`);

export const delete_certificate_template = (id) =>
  API.delete(`${CERTIFICATE_TEMPLATE}${id}`);

export const get_certificate_template_list = (pageNum, filters) =>
  API.get(CERTIFICATE_TEMPLTE_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

//signature
export const get_signature_list = (pageNum, filters) =>
  API.get(SIGNATURE_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const add_signature = (formData) =>
  API.post(SIGNATURE, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const edit_signature = (id, formData) =>
  API.patch(`${SIGNATURE}${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const get_signature_by_id = (id) => API.get(`${SIGNATURE}${id}`);

export const delete_signature = (id) => API.delete(`${SIGNATURE}${id}`);

//receipt
export const receipt_list = (pageNum, filterParams) =>
  API.get(RECEIPT_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
    },
  });

export const download_receipt = (id) =>
  API_FOR_QR.get(`${RECEIPT_DOWNLOAD}${id}/download`);

// Offline attendance module
export const get_courses_batches = (pageNum, filters, searchString) =>
  API.get(GET_COURSES_BATCHES, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(searchString ? { searchString: searchString } : {}),
    },
  });

// get lessons from courseId and batchId
export const get_lessons = (courseId, batchId, pageNum, filters) =>
  API.get(GET_LESSONS, {
    params: {
      courseId: courseId,
      batchId: batchId,
      page: pageNum,
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
    },
  });

// add attendance
export const add_attendance = (bodyData) => API.post(ADD_ATTENDANCE, bodyData);

export const get_attendance_list = (courseId, batchId, traineeId, page) => API.get(GET_ATTENDANCE, {
  params: {
    courseId,
    batchId,
    traineeId,
    page
  },
});

//Payments
export const payment_list = (pageNum, filterParams, sortOptionJSON) =>
  API.get(PAYMENT_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
      ...(sortOptionJSON
        ? { sortOptionJSON: JSON.stringify(sortOptionJSON) }
        : {}),
    },
  });

export const payment_Details = (paymentID) =>
  API.get(`${PAYMENT_DETAILS}/${paymentID}`);

// update attendace
export const update_attendace = (sessionId, bodyData) =>
  API.put(`${ADD_ATTENDANCE}/${sessionId}`, bodyData);

// get session list
export const get_session_list = (courseId, batchId, pageNum) =>
  API.get(GET_SESSION, {
    params: {
      courseId: courseId,
      batchId: batchId,
      page: pageNum,
      // lessonId: lessonId,
    },
  });

// get session data by id
export const get_session_by_id = (lessonId, pageNum, filterParams) =>
  API.get(`${GET_SESSION}/${lessonId}/attendance`, {
    params: {
      page: pageNum,
      ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
    },
  });

//get the course enroll batch details
export const get_course_batch_details = (id) => API.get(`${BATCH_COURSE}${id}`);


// Enroll trainee(s) for a particular course
export const enrolled_trainee_course = (payload) =>
  API.post(`${COURSE}enrollments`, payload);

//enrollment-payment
export const enrollment_payment = (payload) => API.post(`${COURSE}enrollment-payment`, payload);
//Approve Reject Payment
export const approve_reject_payment = (paymentID, bodyData) =>
  API.post(`${APPROVE_REJECT_PAYMENT}/${paymentID}`, bodyData);

// get batch schedule dates
export const batch_scheduled_dates = (batchID) =>
  API.get(`${BATCH_SCHEDULED_DATES}${batchID}/attendance-calendar`);

//assessment
export const add_assessment = (assessmentData) =>
  API.post(ASSESSMENT, assessmentData);
export const get_assessment_list = (pageNum, filters) =>
  API.get(ASSESSMENT_LIST, {
    params: {
      page: pageNum,
      ...Object.fromEntries(
        filters.map((filter) => [
          {
            CourseID: "courseId",
            AssessmentName: "search",
            Status: "status",
          }[filter.field],
          filter.filterValues?.[0],
        ]),
      ),
    },
  });
export const get_assessment_by_course_id = (courseId, pageNum, filters) =>
  API.get(`${COURSE}${courseId}/assessment`, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
    },
  });
export const update_assessment_by_id = (id, bodyData) =>
  API.patch(`${ASSESSMENT}${id}`, bodyData);
export const delete_assessment = (id) => API.delete(`${ASSESSMENT}${id}`);
export const get_assessment_by_id = (id) => API.get(`${ASSESSMENT}${id}`);

// get courses list for trainer login
export const instructor_courses = (pageNum, searchString) =>
  API.get(`${INSTRUCTOR_COURSES}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString: searchString } : {}),
    },
  });

// get batches list for trainer login
export const get_instructor_batch_list = (pageNum, filters) =>
  API.get(INSTRUCTOR_BATCH_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

// admin and super admin courses and batches list
export const get_admins_courses_and_batches = (
  pageNum,
  filters,
  searchString,
) =>
  API.get(ADMINS_COURSES_AND_BATCHES, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(searchString ? { searchString: searchString } : {}),
    },
  });

// admin and super admin sessions list
export const get_admins_sessions_list = (courseId, batchId, pageNum) =>
  API.get(`${ADMINS_SESSIONS_LIST}`, {
    params: {
      courseId: courseId,
      batchId: batchId,
      page: pageNum,
    },
  });

// admin and super admin sessions wise attendance list
export const get_admins_sessions_wise_attendance_list = (
  sessionId,
  pageNum,
  filterParams,
) =>
  API.get(`${ADMINS_SESSIONS_WISE_ATTENDANCE_LIST}${sessionId}/attendance`, {
    params: {
      page: pageNum,
      ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
    },
  });

// channel partner courses and batches list
export const get_channel_partner_courses_and_batches = (
  pageNum,
  filters,
  searchString,
) =>
  API.get(CHANNEL_PARTNER_COURSES_AND_BATCHES, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(searchString ? { searchString: searchString } : {}),
    },
  });

// channel partner sessions wise attendance list
export const get_channel_partner_sessions_wise_attendance_list = (
  sessionId,
  pageNum,
  filterParams,
) =>
  API.get(
    `${CHANNEL_PARTNER_SESSIONS_WISE_ATTENDANCE_LIST}${sessionId}/attendance`,
    {
      params: {
        page: pageNum,
        ...(filterParams?.length ? { filtersJSON: filterParams } : {}),
      },
    },
  );

//get  documents approval list
export const get_pending_document_approvals = (pageNum, filterParams) =>
  API.get(DOCUMENT_APPROVALS, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
    },
  });
//trainee assement list
export const get_trainee_assesment_list = (id, pageNum, filterParams) =>
  API.get(`${TRAINEE_ASSESSMENT_LIST}${id}/trainee-assessment`, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
    },
  });

// Assessment Artifacts
export const create_assessment_artifact = (bodyData) =>
  API.post(`${ASSESSMENT_ARTIFACT}`, bodyData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const update_assessment_artifact = (id, bodyData) =>
  API.patch(`${ASSESSMENT_ARTIFACT}${id}`, bodyData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const get_assessment_artifact_by_id = (id) =>
  API.get(`${ASSESSMENT_ARTIFACT}${id}`);
export const delete_assessment_artifact = (id) =>
  API.delete(`${ASSESSMENT_ARTIFACT}${id}`);
export const delete_assessment_artifact_file = (id, fileID) =>
  API.delete(`${ASSESSMENT_ARTIFACT}${id}/file/${fileID}`);
export const get_assessment_artifact_list = (
  pageNum,
  filters,
  courseId,
  batchId,
  traineeId,
) =>
  API.get(ASSESSMENT_ARTIFACT_LIST, {
    params: {
      page: pageNum,
      ...(courseId ? { CourseID: courseId } : {}),
      ...(batchId ? { BatchID: batchId } : {}),
      ...(traineeId ? { TraineeID: traineeId } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

// trainee assessment artifacts
export const get_trainee_assessment_artifact_files = (traineeId, assessmentId,) =>
  API.get(
    `${TRAINEE_ASSESSMENT_ARTIFACT_FILES}${traineeId}/assessment/${assessmentId}/artifact-files`,
  );

//Channel Partner Enrolled Course List
export const get_channel_partner_enrolled_course_list = (pageNum, filterParams, searchString, sortOptionJSON) =>
  API.get(CHANNEL_PARTNER_ENROLLED_COURSES_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(sortOptionJSON
        ? { sortOptionJSON: JSON.stringify(sortOptionJSON) }
        : {}),
    },
  });

//get the course enroll batch details
export const get_course_schedule_details = (id) => API.get(`${CHANNEL_PARTNER_ENROLLED_COURSE_SCHEDULE}/${id}`);

//get the course enroll batch details
export const get_course_reviews = (id) => API.get(`${ENROLLED_COURSE_REVIEWS}/${id}`);

//Trainee Attendance
export const channel_partner_trainee_enrolled_course_attendance = (
  courseId,
  batchId,
) =>
  API.get(
    `${CHANNEL_PARTNER_TRAINEE_ENROLLED_COURSE_ATTENDANCE}?courseId=${courseId}&batchId=${batchId}`,
  );

//Course Feedback
export const add_course_rating = (data) => API.post(COURSE_RATING, data);

//get the course enroll batch details
export const get_channel_partner_course_enrollment_details = (courseId) => API.get(`${CHANNEL_PARTNER_ENROLLED_COURSE_DETAILS}/${courseId}/enrollment-details`);

//Get course pending enrolled trainees list against course
export const get_pending_enrolled_trainees = (courseId, pageNum, filterParams, searchString, sortOptionJSON) =>
  API.get(`${PENDING_ENROLLED_TRAINEES_LIST}/${courseId}`, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(sortOptionJSON
        ? { sortOptionJSON: JSON.stringify(sortOptionJSON) }
        : {}),
    },
  });

//Get course pending enrolled trainees list against course
export const get_enrolled_trainees_list_against_course = (courseId, pageNum, filterParams, searchString, sortOptionJSON) =>
  API.get(`${ENROLLED_TRAINEE_LIST_AGAINST_COURSE}/${courseId}/channel-partner/trainees`, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(sortOptionJSON
        ? { sortOptionJSON: JSON.stringify(sortOptionJSON) }
        : {}),
    },
  });


// Course Ratings
export const get_course_ratings = (courseId, pageNum) =>
  API.get(`${COURSE_RATINGS}${courseId}?page=${pageNum}&noOfRecordsPerPage=10`);

export const delete_course_rating = (id) =>
  API.delete(`${DELETE_COURSE_RATING}${id}`);

//get the course enroll batch details
export const get_course_upcoming_batches = (courseId) => API.get(`${UPCOMING_BATCHES}/${courseId}/upcoming`);

//get  Admin profile 
export const get_admin_profile_details = () => API.get(ADMIN_PROFILE);
//update admin profile
export const update_admin_profile_details = (bodyData) =>
  API.patch(ADMIN_PROFILE, bodyData);

// Instructor profile
export const get_instructor_profile_details = () => API.get(INSTRUCTOR_PROFILE);
//update Instructor profile
export const update_instructor_profile_details = (bodyData) =>
  API.patch(INSTRUCTOR_PROFILE, bodyData);

//
export const get_payment_approval_request_list = (pageNum, filters) =>
  API.get(PAYMENT_APPROVAL_REQUEST_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_channel_partner_course_list = (
  pageNum,
  filterParams,
  searchString,
  sortOptionJSON,
) =>
  API.get(CHANNEL_PARTNER_COURSE_LIST, {
    params: {
      page: pageNum,
      ...(filterParams?.filters ? { filtersJSON: filterParams.filters } : {}),
      ...(searchString ? { searchString } : {}),
      ...(sortOptionJSON
        ? { sortOptionJSON: JSON.stringify(sortOptionJSON) }
        : {}),
    },
  });

//Channel-Partner-profile get
export const get_channel_partner_profile_details = () =>
  API.get(CHANNEL_PARTNER_PROFILE);
//channel-Partner-profile Update
export const update_channel_partner_profile_details = (formData) =>
  API.patch(`${CHANNEL_PARTNER_PROFILE}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const get_issuance_list = (pageNum, filters) =>
  API.get(ISSUANCE_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_issuance_eligible_trainees = (id, page1, page2, filters) =>
  API.get(`${ISSUANCE_ELIGIBLE_TRAINEES}${id}`, {
    params: {
      page1: page1,
      page2: page2,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_user_certificates_by_batch = (batchId, pageNum, filters) =>
  API.get(`${USER_CERTIFICATES_BATCH}${batchId}`, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const generate_user_certificate = (batchId, bodyData) =>
  API.post(`${GENERATE_USER_CERTIFICATE}${batchId}`, bodyData);
//trainee certificates
export const get_trainee_certificates = (id) => API.get(`${TRAINEE_CERTIFICATES}${id}`);

export const get_published_assessment_by_course_id = (courseId, traineeID, pageNum, filters) =>
  API.get(`${COURSE}${courseId}/published-assessment`, {
    params: {
      TraineeID: traineeID,
      page: pageNum,
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
    },
  });

// save trainee certificate image
export const save_trainee_certificate_image = (certificateID, bodyData) =>
  API.patch(`${TRAINEE_CERTIFICATE_IMAGE}/${certificateID}`, bodyData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  
// Attendance edit period lock
export const get_attendance_lock = () => API.get(`${BASE_URL}/lock/1`);
export const update_attendance_lock = (bodyData) => API.patch(`${BASE_URL}/lock/1`, bodyData);

export const get_admin_dashboard = (pageNum = 1) =>
  API.get(ADMIN_DASHBOARD, {
    params: {
      page: pageNum,
    },
  });

//admin reports
export const get_certificate_issuance_report = (filters, pageNum) =>
  API.get(CERTIFICATE_ISSUANCE_REPORT, {
    params: {
      ...(filters?.length ? { filtersJSON: filters } : {}),
      page: pageNum,
    },
  });

export const get_attendance_report = (filters, pageNum) =>
  API.get(ATTENDANCE_REPORT, {
    params: {
      ...(filters?.length ? { filtersJSON: filters } : {}),
      page: pageNum,
    },
  });

export const get_certificate_pending_report = (pageNum, filters) =>
  API.get(CERTIFICATE_PENDING_REPORT, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_course_enrollment_report = (pageNum, filters) =>
  API.get(COURSE_ENROLLMENT_REPORT, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_channel_partner_dashboard_summary = (pageNum = 1) =>
  API.get(CHANNEL_PARTNER_DASHBOARD_SUMMARY, {
    params: {
      page: pageNum,
    },
  });
  
export const get_instructor_daily_attendance_report = (filters, pageNum) =>
  API.get(INSTRUCTOR_DAILY_ATTENDANCE_REPORT, {
    params: {
      ...(filters?.length ? { filtersJSON: filters } : {}),
      page: pageNum,
    },
  });

export const get_instructor_dashboard_summary = (
  pageNum = 1,
) =>
  API.get(INSTRUCTOR_DASHBOARD_SUMMARY, {
    params: {
      page: pageNum,
    },
  });

export const get_channel_partner_course_enrollment_report = (
  pageNum,
  filters,
) =>
  API.get(CHANNEL_PARTNER_COURSE_ENROLLMENT_REPORT, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
      },
  });
  
export const get_instructor_assessment_report = (filters, pageNum) =>
  API.get(INSTRUCTOR_ASSESSMENT_REPORT, {
    params: {
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
      page: pageNum,
    },
  });

export const get_instructor_assessment_report_details = (
  assessmentId,
  batchId,
  filters,
  pageNum,
) =>
  API.get(`${INSTRUCTOR_ASSESSMENT_REPORT}/${assessmentId}/batch/${batchId}`, {
    params: {
      ...(filters?.length ? { filtersJSON: JSON.stringify(filters) } : {}),
      page: pageNum,
    },
  });